import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import './ClientApplicationsSummaryReminderItem.css';

export default function ClientApplicationsSummaryReminderItem({reminderItem}) {
  return (
    <div className='ClientApplicationsSummaryReminderItem'>
        <div className='title'>
            <span><strong>{reminderItem.RPNumber}</strong>&nbsp;</span>
            <span>(<i>{capitalizeFirstLetter(reminderItem.applicationType)}</i>)</span>
        </div>
        <div className='message'>
            <span><strong>{reminderItem.message}</strong>&nbsp;</span>
            <span className='condition'>[Sent {reminderItem.numberOfDays} day{reminderItem.numberOfDays!==1? 's':''} {reminderItem.beforeOrAfter} {reminderItem.fieldOfInterest}]</span>
        </div>
        <div className='sentDaysCount'>
            <span>{reminderItem.sentDaysCount} day{reminderItem.sentDaysCount!==1? 's':''} ago</span>
        </div>
    </div>
  )
}
